<template>
  <el-dialog
    :title="$t('text.confirmation')"
    :visible.sync="visible"
    width="30%">
    <span>{{ $t('text.newDataAndNeedRefresh') }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="handleConfirm">{{$t('button.refresh')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    menuBadgeKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      activated: false,
    }
  },
  computed: {
    ...mapState({
      pathBadgeMap: (state) => state.pathBadgeMap,
      menuBadge: (state) => state.menuBadge,
      disposedMenuBadge: (state) => state.disposedMenuBadge,
    }),
    menuBadgeCount() {
      return this.menuBadge[this.menuBadgeKey] || 0
    },
    disposedMenuBadgeCount() {
      return this.disposedMenuBadge[this.menuBadgeKey] || 0
    },
  },
  watch: {
    menuBadgeCount(val) {
      if (!this.activated) {
        return
      }
      if (val > this.disposedMenuBadgeCount) {
        this.visible = true
      }
    },
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.disposeMenuBadge()
    },
    handleConfirm() {
      this.visible = false
      this.$emit('confirm')
      this.disposeMenuBadge()
    },
    disposeMenuBadge() {
      this.$store.commit('setDisposedMenuBadge', {
        [this.menuBadgeKey]: this.menuBadgeCount
      })
    }
  },
  activated() {
    this.activated = true
  },
  deactivated() {
    this.activated = false
  }
}
</script>
